import { render, staticRenderFns } from "./PlatformsList.vue?vue&type=template&id=6dafd77e&scoped=true&"
import script from "./PlatformsList.vue?vue&type=script&lang=js&"
export * from "./PlatformsList.vue?vue&type=script&lang=js&"
import style0 from "./PlatformsList.vue?vue&type=style&index=0&id=6dafd77e&lang=scss&scoped=true&"
import style1 from "./PlatformsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dafd77e",
  null
  
)

export default component.exports